module.exports = __webpack_public_path__ + "img/ai-quiz-generator-hover.c9c5f0b9.png";